<template>
  <div class="py-6 px-8">
    <h-header />
    <v-tabs v-model="tab" color="realEstate">
      <v-tab @click="fetchPending">
        {{ $t('hausefulInvoices.pending') }}
      </v-tab>
      <v-tab @click="fetchSent">
        {{ $t('hausefulInvoices.sent') }}
      </v-tab>

      <div class="tabs__filters">
        <HostInvoiceFilters v-if="showSentInvoicesFilters" />
      </div>
    </v-tabs>

    <v-card outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <HostPendingInvoices @sendInvoiceData="sendInvoiceData" :invoices="invoices" :loading="isLoading" />
        </v-tab-item>
        <v-tab-item>
          <HostSentInvoices @sendInvoiceData="sendInvoiceData"  />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

     <ModalSendHostInvoice :invoice="invoice" />
     <ModalResendHostInvoice :invoice="invoice" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import HostPendingInvoices from './components/HostPendingInvoices'
import HostSentInvoices from './components/HostSentInvoices'

import HostInvoiceFilters from './filters/HostInvoiceFilters'

import ModalSendHostInvoice from './modals/SendHostInvoiceModal'
import ModalResendHostInvoice from './modals/ResendHostInvoiceModal'

export default {
  name: 'HostInvoicesUser',

  components: {
    HostPendingInvoices,
    HostSentInvoices,

    HostInvoiceFilters,

    ModalSendHostInvoice,
    ModalResendHostInvoice,
  },

  computed: {
    ...mapGetters(['isLoading', 'hostUserPendingInvoices']),

    showSentInvoicesFilters() {
      return this.tab === 1
    },
  },

  watch: {
    hostUserPendingInvoices(value) {
      if (!value) return
      this.transformInToArray(value)
    }
  },

  methods: {
    ...mapActions(['fetchHostUserInvoices', 'fetchHostUserPendingInvoices']),
    ...mapMutations(['setFilters', 'setTotalPages', 'setCurrentPage', 'setHostUserInvoices', 'setHostUserPendingInvoices']),

    resetInvoicesListAndFilters() {
      this.setFilters(null)
      this.setTotalPages(0)
      this.setCurrentPage(1)
      this.setHostUserInvoices([])
      this.setHostUserPendingInvoices([])
    },

    fetchSent() {
      this.resetInvoicesListAndFilters()
      this.fetchHostUserInvoices()
    },

    fetchPending() {
      this.resetInvoicesListAndFilters()
      this.fetchHostUserPendingInvoices()
    },

    transformInToArray(pendingInvoices) {
      if (!pendingInvoices) return

      const resultArray = Object.keys(pendingInvoices).map(month => {
        return {
          'month': month,
          'month_name': pendingInvoices[month].month_name,
          'first_half': pendingInvoices[month].first_half,
          'second_half': pendingInvoices[month].second_half,
        }
      })

      this.invoices = resultArray
    },

    sendInvoiceData(invoiceData) {
      this.invoice = invoiceData
    },
  },

  data() {
    return {
      tab: 0,
      headers: [],
      invoices: [],
      invoice: {},
    }
  },

  mounted() {
    this.fetchPending()
  },
}
</script>
